const getIsAvailableForSubscription = (serverVariant, purchaseTypePrices)=>{
    const hasAvailableForSubscriptionAttribute = serverVariant.isAvailableForSubscription;
    const hasSubscriptionPrice = !!purchaseTypePrices['subscription-purchase'];
    if (hasAvailableForSubscriptionAttribute && !hasSubscriptionPrice) {
        console.error(`Product is available for subscription, but has no subscription price.`, {
            sku: serverVariant.sku,
            name: serverVariant.displayName
        });
        return false;
    }
    return hasAvailableForSubscriptionAttribute;
};

export { getIsAvailableForSubscription };
//# sourceMappingURL=get-is-available-for-subscription.js.map
